import request from '@/utils/request'
export function putMsg(data) {
    return request({
      url: '/msgwall/msg',
      method: 'post',
      data
    })
}



// WEBPACK FOOTER //
// ./src/api/new_msg.js